import { Stack, useNavigationContainerRef } from 'expo-router';
import { useDrawerType } from 'hooks/useDrawerType';
import { strings } from 'strings';

export default function Layout() {
  const drawerType = useDrawerType();

  const containerRef = useNavigationContainerRef();

  const headerShown =
    drawerType !== 'permanent' &&
    containerRef.getCurrentRoute()?.name.includes('reportId');

  return (
    <Stack
      screenOptions={{
        headerShown: headerShown,
        headerTitle: strings.ButtonTextBack,
      }}
    />
  );
}
